import { Checkbox, Popover } from "antd";
import { MdOutlineViewColumn } from "react-icons/md";
import Button from "shared/components/Button";

const ColumnsSettings = ({ options, hiddenColumns, onChange, translate }) => {
  const visibleColumns = options
    .map(({ value }) => value)
    .filter((value) => !hiddenColumns.includes(value));

  const handleChange = (checkedValues) =>
    onChange(
      options
        .filter(
          ({ value, disabled }) => !disabled && !checkedValues.includes(value),
        )
        .map(({ value }) => value),
    );

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      title={translate.TITLE}
      content={
        <Checkbox.Group
          className="columns-settings__list"
          options={options}
          value={visibleColumns}
          onChange={handleChange}
        />
      }
    >
      <Button type="primary--outlined" icon={<MdOutlineViewColumn size={20} />}>
        {translate.BUTTON}
      </Button>
    </Popover>
  );
};

export default ColumnsSettings;
